<figure class="m-0">
  <figcaption *ngIf="title" class="fw-semibold mb-2 text-center">{{ title }}</figcaption>
  <ul class="visually-hidden" [attr.aria-label]="(title || 'Chart') + ' data'">
    <li *ngFor="let s of accessibleSeriesData">
      {{ s.seriesName }}
      <ul>
        <li *ngFor="let p of s.points">{{ p.category }}: {{ p.value }}</li>
      </ul>
    </li>
  </ul>
  <div #chartTarget style="width: 100%" [style.height.px]="chartHeight" aria-hidden="true"></div>
</figure>
